import { useContext } from 'react';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Grid, Icon, LinearProgress } from '@mui/material';
import { useForm } from 'react-hook-form';
import { CustomPagination } from 'utils/functions';
import {
  dropBoolean,
  dropEpi,
  dropEpc,
  dropUnidade,
  dropTipoAvaliacao,
} from 'utils/drops';
import { useDialog } from 'components/Modals';
import { GridContext } from 'contexts/GridContext';
import VirtualDrop from 'components/VirtualDrop';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Input from 'components/Input';
import Title from '../Components/Title';
import localeText from 'utils/localeText';
import moment from 'moment';

const FatorRisco = ({ drops, loading, pessoal = {}, onSubmit, onDelete }) => {
  const { openDialog } = useDialog();
  const fatores = pessoal?.Fatores ?? [];

  const Modal = ({ item }) => {
    const defaultValues = {
      rotina: 'PessoalFatorrisco',
      id: item?.id,
      pessoal_id: pessoal?.id,
      diinicondicao: item?.diinicondicao || null,
      ambiente_id: item?.ambiente_id || null,
      dscativdes: item?.dscativdes || '',
      atividade_exprisco_id: item?.atividade_exprisco_id || null,
      fator_risco_id: item?.fator_risco_id || null,
      tpaval: item?.tpaval || null,
      intconc: item?.intconc || '',
      unmed: item?.unmed || null,
      limtol: item?.limtol || '',
      tecmedicao: item?.tecmedicao || '',
      insalubridade: item?.insalubridade || null,
      periculosidade: item?.periculosidade || null,
      aposentesp: item?.aposentesp || null,
      utilizepc: item?.utilizepc || null,
      eficepc: item?.eficepc || null,
      condfuncto: item?.condfuncto || null,
      utilizepi: item?.utilizepi || null,
      dscepi: item?.dscepi || '',
      caepi: item?.caepi || '',
      eficepi: item?.eficepi || null,
      przvalid: item?.przvalid || null,
      periodictroca: item?.periodictroca || null,
      higienizacao: item?.higienizacao || null,
      usoinint: item?.usoinint || null,
      medprotecao: item?.medprotecao || null,
      meterg: item?.meterg || '',
      respreg_id: item?.respreg_id || null,
      observacao: item?.observacao || '',
    };
    const { postLoading } = useContext(GridContext);
    const { control, handleSubmit } = useForm({ defaultValues });

    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Title title="Identificação da Condição" disableMargin />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            type="date"
            control={control}
            name="diinicondicao"
            label="Data de Início da Condição"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            name="ambiente_id"
            control={control}
            options={drops?.Ambiente}
            label="Ambiente de Trabalho"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            name="dscativdes"
            control={control}
            label="Descrição da Atividade"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="atividade_exprisco_id"
            options={drops?.AtividadeExprisco}
            label="Atividade Exposta ao Risco"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Dropdown
            control={control}
            name="fator_risco_id"
            options={drops?.FatorRisco}
            label="Fator de Risco"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Avaliação Técnica" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="tpaval"
            control={control}
            label="Tipo de Avaliação"
            options={dropTipoAvaliacao}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <InputMask
            name="intconc"
            control={control}
            label="Intensidade / Concentração"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="unmed"
            control={control}
            options={dropUnidade}
            label="Unidade de Medida"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputMask
            name="limtol"
            control={control}
            label="Limite de Tolerância"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input
            name="tecmedicao"
            control={control}
            label="Técnica de Medição"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Impactos Trabalhistas" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            name="insalubridade"
            label="Insalubridade"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            name="periculosidade"
            options={dropBoolean}
            label="Periculosidade"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="aposentesp"
            control={control}
            options={dropBoolean}
            label="Aposentadoria Especial"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="EPC (Equipamento de Proteção Coletiva)" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="utilizepc"
            control={control}
            options={dropEpc}
            label="Utiliza EPC"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="eficepc"
            control={control}
            options={dropBoolean}
            label="Eficácia do EPC"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="condfuncto"
            control={control}
            options={dropBoolean}
            label="Condições de Funcionamento"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="EPI (Equipamento de Proteção Individual)" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="utilizepi"
            control={control}
            options={dropEpi}
            label="Utiliza EPI"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="eficepi"
            control={control}
            options={dropBoolean}
            label="Eficácia do EPI"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="przvalid"
            control={control}
            options={dropBoolean}
            label="Prazo de Validade"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="dscepi" control={control} label="Descrição do EPI" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Input name="caepi" control={control} label="CA do EPI" />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            name="periodictroca"
            options={dropBoolean}
            label="Periodicidade de Troca"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            control={control}
            name="higienizacao"
            label="Higienização"
            options={dropBoolean}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Dropdown
            name="usoinint"
            control={control}
            options={dropBoolean}
            label="Uso Ininterrupto"
          />
        </Grid>
        <Grid item xs={12}>
          <Title title="Medidas de Proteção Complementares" />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Dropdown
            control={control}
            name="medprotecao"
            options={dropBoolean}
            label="Medidas de Proteção"
          />
        </Grid>
        <Grid item xs={12} sm={10}>
          <Input name="meterg" control={control} label="Método de Ergonomia" />
        </Grid>
        <Grid item xs={12}>
          <Title title="Informações Administrativas" />
        </Grid>
        <Grid item xs={12}>
          <VirtualDrop
            control={control}
            name="respreg_id"
            options={drops?.Entidade}
            label="Responsável Técnico"
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            rows={3}
            multiline
            name="observacao"
            control={control}
            label="Observação"
          />
        </Grid>
        <Grid item xs={12} textAlign="center">
          <Button
            color="primary"
            loading={postLoading}
            variant="contained"
            onClick={handleSubmit(onSubmit)}
          >
            Salvar
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Title
          title="Fatores de Risco"
          disableMargin
          rightButton={
            <Button
              color="primary"
              variant="outlined"
              onClick={() => openDialog(<Modal />, 'Adicionar Fator de Risco')}
            >
              Adicionar
            </Button>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <DataGrid
          rows={fatores}
          columns={[
            {
              field: 'diinicondicao',
              headerName: 'Data de Início',
              width: 200,
              sortable: false,
              valueGetter: ({ value }) =>
                value && moment(value).format('DD/MM/YYYY'),
            },
            {
              field: 'ambiente',
              headerName: 'Ambiente de Trabalho',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'atividade',
              headerName: 'Atividade',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'fator_risco',
              headerName: 'Fator de Risco',
              minWidth: 300,
              flex: 1,
              sortable: false,
            },
            {
              field: 'tpaval',
              headerName: 'Tipo de Avaliação',
              width: 200,
              sortable: false,
            },
            {
              field: 'intconc',
              headerName: 'Intensidade / Concentração',
              width: 200,
              sortable: false,
            },
            {
              field: 'unmed',
              headerName: 'Unidade',
              width: 100,
              sortable: false,
            },
            {
              field: 'insalubridade',
              headerName: 'Insalubridade',
              width: 120,
              sortable: false,
            },
            {
              field: 'periculosidade',
              headerName: 'Periculosidade',
              width: 120,
              sortable: false,
            },
            {
              field: 'aposentesp',
              headerName: 'Aposentadoria Especial',
              width: 180,
              sortable: false,
            },
            {
              field: 'actions',
              headerName: 'Ações',
              type: 'actions',
              width: 100,
              getActions: ({ row }) => [
                <GridActionsCellItem
                  icon={<Icon>edit</Icon>}
                  label="Editar"
                  onClick={() =>
                    openDialog(<Modal item={row} />, 'Editar Fator de Risco')
                  }
                />,
                <GridActionsCellItem
                  icon={<Icon>delete</Icon>}
                  label="Excluir"
                  onClick={() =>
                    onDelete({ rotina: 'PessoalFatorrisco', id: row?.id })
                  }
                />,
              ],
            },
          ]}
          autoHeight
          pagination
          pageSize={10}
          density="compact"
          loading={loading}
          disableColumnMenu
          showCellRightBorder
          showColumnRightBorder
          disableSelectionOnClick
          localeText={localeText}
          getRowHeight={() => 'auto'}
          components={{
            Pagination: CustomPagination,
            LoadingOverlay: LinearProgress,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default FatorRisco;
